<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" class="relative z-10">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4 text-center">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="
                w-full
                max-w-md
                transform
                overflow-hidden
                rounded-2xl
                bg-white
                p-6
                text-left
                align-middle
                shadow-xl
                transition-all
              "
            >
              <DialogTitle as="h3" class="text-lg font-medium leading-6 text-gray-900">
                Warning
              </DialogTitle>
              <div class="mt-2">
                <p class="text-sm text-gray-500" v-html="warningText"></p>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogOverlay,
} from '@headlessui/vue';

export default {
  name: 'BrowserCheckModal',
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogPanel,
    DialogTitle,
    DialogOverlay,
  },
  mounted() {
    this.checkBrowser();
  },
  data() {
    return {
      platformSettings: this.$page.props.platformSettings, // data from app/Http/Middleware/HandleInertiaRequests.php
      isOpen: false,
      browserNotAllowedWarningText:
        'Please use Google Chrome to get the best VCE experience. <a href="https://www.google.com/intl/en/chrome/" target="_blank" class="outline-none text-blue-600 dark:text-blue-500 hover:underline">Download here.</a>',
      mobileBrowserWarningText:
        'Mobile devices are not supported! To get the best VCE experience join via laptop or desktop using Google Chrome.',
      warningText: '',
    };
  },
  methods: {
    checkBrowser() {
      switch (true) {
        case this.checkIfMobile():
          this.warningText = this.mobileBrowserWarningText;
          this.isOpen = true;
          break;
        case this.checkIfBrowserAllowed():
          this.warningText = this.browserNotAllowedWarningText;
          this.isOpen = true;
          break;
        default:
          this.isOpen = false;
      }
    },

    checkIfBrowserAllowed() {
      const browserName = this.getBrowserName(false);

      if (this.platformSettings.Browser !== undefined) {
        return !this.platformSettings.Browser.includes(browserName);
      }

      return !browserName.includes('Chrome');
    },

    checkIfMobile() {
      const userAgent = navigator.userAgent;

      if (this.platformSettings.Device !== undefined) {
        return userAgent.includes('Mobile') && !this.platformSettings.Device.includes('Mobile');
      }

      return userAgent.includes('Mobile');
    },

    getBrowserName() {
      const ua = navigator.userAgent;
      const withVersionNumber = null;
      let tem;
      let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return `IE ${tem[1] || ''}`;
      }
      if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) {
          return withVersionNumber ? tem.slice(1).join(' ').replace('OPR', 'Opera') : 'Opera';
        }
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];

      tem = ua.match(/version\/(\d+)/i);
      if (tem != null) {
        M.splice(1, 1, tem[1]);
      }
      return withVersionNumber ? M.join(' ') : M[0];
    },
  },
};
</script>
